import { captureException } from '@sentry/vue'
import { defineStore } from 'pinia'

import PlayerRepository from '@/app/repositories/player-repository'
import { Song } from '@/common/models/data/dashboard/song'

const usePlayerStore = defineStore('player', {
    state: () => ({
        currentSong: new Song(),
        playing: false,
        noDataString: '',
        streamUrl: ''
    }),
    actions: {
        async loadStreamUrl (): Promise<void> {
            try {
                this.streamUrl = await PlayerRepository.url()
            } catch (e) {
                captureException(e, { level: 'error' })

                window.setTimeout(async (): Promise<void> => {
                    this.loadStreamUrl()
                })
            }
        },
        async loadMetadata (): Promise<void> {
            try {
                this.currentSong = await PlayerRepository.currentSong()
            } catch (e) {
                captureException(e, { level: 'error' })

                this.currentSong = new Song(this.noDataString)
            }
        },
        togglePlaying (): void {
            this.playing = !this.playing
        }
    },
    getters: {
        streamSource: (state): string => {
            if (state.streamUrl.endsWith('/')) {
                return `${state.streamUrl};`
            }

            return `${state.streamUrl}/;`
        }
    }
})

export {
    usePlayerStore
}
